import React from 'react';

import styles from './StartPlayer.module.scss';
import urlJoin from 'url-join';
import {CDN_IMAGE_URL} from 'configs';

function StartPlayer() {
  return (
    <div className={styles['player']}>
      <video
        src={urlJoin(
          CDN_IMAGE_URL,
          'p/landing/animations/verified-certification-cta.mp4'
        )}
        autoPlay
        muted
        playsInline
        loop
        loading="lazy"
      />
    </div>
  );
}

export default StartPlayer;
